module.exports = __webpack_public_path__ + "static/media/md-help-circle.4c803364.svg";